<template>
  <div>
    <div class="c-search" @click="jumpToSearch">
      <i class="iconfont icon-sousuo f32"></i> 搜索
    </div>
    <carousel class="mb30" :carouselList="carouselList"></carousel>
    <div class="c-card">
      <div class="item-wrap" :class="active == 1 ? 'active':''" @click="jumpToTrain()">
        <div class="item item1">训练营</div>
        <span class="bar">
          <i></i>
        </span>
      </div>
      <div class="item-wrap" :class="active == 2 ? 'active':''" @click="jumpToOfflineClass()">
        <div class="item item2">线上课</div>
        <span class="bar">
          <i></i>
        </span>
      </div>
      <div class="item-wrap" :class="active == 3 ? 'active':''" @click="jumpToLiveBroadcast()">
        <div class="item item3">直播</div>
        <span class="bar">
          <i></i>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import carousel from '@/pages/notes/components/carousel.vue'
export default {
  components: {
    carousel,
  },
  props: {
    active: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      carouselList: [],
    }
  },
  mounted() {
    this.getCarousel()
  },
  methods: {
    async getCarousel() {
      let res = await this.api.note.getCarousel(1)
      if (res && res.code == 200) {
        if (Object.prototype.toString.apply(res.data.items) == '[object Array]')
          this.carouselList = res.data.items
      }
    },
    jumpToTrain() {
      this.$router.push({
        name: 'train-list',
        query: { adminId: this.$route.query.adminId },
      })
    },
    jumpToOfflineClass() {
      this.$router.push({
        name: 'online-course-list',
        query: { adminId: this.$route.query.adminId },
      })
    },
    jumpToLiveBroadcast() {
      this.$router.push({
        name: 'live-broadcast-list',
        query: { adminId: this.$route.query.adminId },
      })
    },
    jumpToSearch() {
      this.$router.push({
        name: 'search',
        query: { reUrl: encodeURIComponent(window.location.href) },
      })
    },
  },
}
</script>

<style lang="less" scoped>
.c-search {
  width: 686px;
  margin: 0 auto 30px;
  background: #f6f6f6;
  border-radius: 36px;
  border: 2px solid #d8d9dc;
  font-size: 28px;
  font-weight: 500;
  color: #aaaaaa;
  line-height: 72px;
  text-align: center;
}
.c-card {
  padding: 0 0 10px;
  display: flex;
  margin: 0 -9px;
  .item-wrap {
    flex: 217px 0 0;
    height: 146px;
    position: relative;
    margin: 0 9px;

    .bar {
      width: 100%;
      height: 4px;
      background: #ff5500;
      position: absolute;
      top: 130px;
      left: 0;
      display: none;

      i {
        width: 0;
        height: 0;
        display: block;
        position: absolute;
        left: 100px;
        top: 0px;
        border-width: 12px;
        border-style: solid;
        border-color: #f50 transparent transparent transparent;
      }
    }
    &.active {
      .bar {
        display: block;
      }
    }
  }
  .item {
    padding-left: 96px;
    width: 217px;
    height: 136px;
    border-radius: 8px;
    font-size: 28px;
    font-weight: 500;
    color: #333333;
    line-height: 136px;
    text-align: center;

    &.item1 {
      background: #fff url('~@/assets/images/home/icon1.png') 24px 50% no-repeat;
      background-size: 80px 80px;
    }
    &.item2 {
      background: #fff url('~@/assets/images/home/icon2.png') 24px 50% no-repeat;
      background-size: 80px 80px;
    }
    &.item3 {
      background: #fff url('~@/assets/images/home/icon3.png') 24px 50% no-repeat;
      background-size: 80px 80px;
    }
  }
}
</style>